export const ClaimKeys = {
  MXP_LANGUAGE: 'https://rezolve.com/mxp_language',
};
